export default {
    "changsheng": {
        "text": ["长生", "沐浴", "冠带", "临官", "帝旺", "衰", "病", "死", "墓", "绝", "胎", "养"],
        "gan": [
            "亥子丑寅卯辰巳午未申酉戌",
            "午巳辰卯寅丑子亥戌酉申未",
            "寅卯辰巳午未申酉戌亥子丑",
            "酉申未午巳辰卯寅丑子亥戌",
            "寅卯辰巳午未申酉戌亥子丑",
            "酉申未午巳辰卯寅丑子亥戌",
            "巳午未申酉戌亥子丑寅卯辰",
            "子亥戌酉申未午巳辰卯寅丑",
            "申酉戌亥子丑寅卯辰巳午未",
            "卯寅丑子亥戌酉申未午巳辰"
        ],
    },
    "nianrigan": {
        "text": "甲乙丙丁戊己庚辛壬癸",
        "classify": {
            "guoyinguiren": {
                "text": "国印贵人",
                "duizhao": "戌亥丑寅丑寅辰巳未申"
            }
        }
    },
    "yuezhi": {
        "text": "寅卯辰巳午未申酉戌亥子丑",
        "classify": {
            "tiandeguiren": {
                "text": "天德贵人",
                "duizhao": "丁申壬辛亥甲癸寅丙乙巳庚"
            },
            "yuedeguiren": {
                "text": "月德贵人",
                "duizhao": "丙甲壬庚丙甲壬庚丙甲壬庚"
            },
            "tianyixing": {
                "text": "天医星",
                "duizhao": "丑寅卯辰巳午未申酉戌亥子"
            }
        }
    },
    "rigan": {
        "text": "甲乙丙丁戊己庚辛壬癸",
        "classify": {
            "tianyiguiren": {
                "text": "天乙贵人",
                "duizhao": ["丑未", "子申", "亥酉", "亥酉", "丑未", "子申", "寅午", "寅午", "卯巳", "卯巳"]
            },
            "taijiguiren": {
                "text": "太极贵人",
                "duizhao": ["子午", "子午", "卯酉", "卯酉", "辰戌丑未", "辰戌丑未", "寅亥", "寅亥", "巳申", "巳申"]
            },
            "wenchangxing": {
                "text": "文昌星",
                "duizhao": "巳午申酉申酉亥子寅卯"
            },
            "shiganlushen": {
                "text": "十干禄神",
                "duizhao": "寅卯巳午巳午申酉亥子"
            },
            "yangren": {
                "text": "羊刃",
                "duizhao": "卯寅午巳午巳酉申子亥"
            },
            "feiren": {
                "text": "飞刃",
                "duizhao": "酉申子亥子亥卯寅午巳"
            },
            "hongyansha": {
                "text": "红艳煞",
                "duizhao": "午申寅未辰辰戌酉子申"
            },
            "jinyuxing": {
                "text": "金舆星",
                "duizhao": "辰巳未申未申戌亥丑寅"
            }
        }
    },
    "nianrizhi": {
        "text": "子丑寅卯辰巳午未申酉戌亥",
        "classify": {
            "jiangxing": {
                "text": "将星",
                "duizhao": "子酉午卯子酉午卯子酉午卯"
            },
            "huagaixing": {
                "text": "华盖星",
                "duizhao": "辰丑戌未辰丑戌未辰丑戌未"
            },
            "yima": {
                "text": "驿马",
                "duizhao": "寅亥申巳寅亥申巳寅亥申巳"
            },
            "taohua": {
                "text": "桃花",
                "duizhao": "酉午卯子酉午卯子酉午卯子"
            },
            "guchen": {
                "text": "孤辰",
                "duizhao": "寅寅巳巳巳申申申亥亥亥寅"
            },
            "guasu": {
                "text": "寡宿",
                "duizhao": "戌戌丑丑丑辰辰辰未未未戌"
            },
            "hongluan": {
                "text": "红鸾",
                "duizhao": "卯寅丑子亥戌酉申未午巳辰"
            },
            "tianxi": {
                "text": "天禧",
                "duizhao": "酉申未午巳辰卯寅丑子亥戌"
            },
            "wangshen": {
                "text": "亡神",
                "duizhao": "亥申巳寅亥申巳寅亥申巳寅"
            },
            "wangshen": {
                "text": "劫煞",
                "duizhao": "巳寅亥申巳寅亥申巳寅亥申"
            }
        }
    },
    "nianzhi": {
        "text": "子丑寅卯辰巳午未申酉戌亥",
        "classify": {
            "zaisha": {
                "text": "灾煞",
                "duizhao": "午卯子酉午卯子酉午卯子酉"
            },
            "sangmen": {
                "text": "丧门",
                "duizhao": "寅卯辰巳午未申酉戌亥子丑"
            },
            "diaoke": {
                "text": "吊客",
                "duizhao": "戌亥子丑寅卯辰巳午未申酉"
            }
        }
    },
    "rizhi": {
        "classify": {
            "tianluo": {
                "text": "天罗",
                "rizhi": "戌亥",
                "duizhao": "亥戌"
            },
            "diwang": {
                "text": "地网",
                "rizhi": "辰巳",
                "duizhao": "巳辰"
            }
        }
    },
    "riganother": {
        "classify": {
            "jielukongwang": {
                "text": "截路空亡",
                "rigan": ["甲己", "乙庚", "丙辛", "丁壬", "戊癸"],
                "duizhao": ["申酉", "午未", "辰巳", "寅卯", "子丑"]
            }
        }
    },
    "rizhu": {
        "classify": {
            "rigui": {
                "text": "日贵",
                "duizhao": ["丁亥", "癸卯"]
            },
            "yegui": {
                "text": "夜贵",
                "duizhao": ["丁酉", "癸巳"]
            },
            "ride": {
                "text": "日德",
                "duizhao": ["甲寅", "戊辰", "丙辰", "庚辰", "壬戌"]
            },
            "kuigang": {
                "text": "魁罡",
                "duizhao": ["壬辰", "庚戌", "戊戌", "庚辰"]
            },
            "yinchayangcuo": {
                "text": "阴差阳错",
                "duizhao": ["丙子", "丁丑", "戊寅", "辛卯", "壬辰", "癸巳", "丙午", "丁未", "戊申", "辛酉", "壬戌", "癸亥"]
            }
        }
    },
    "shizhu": {
        "classify": {
            "jinshen": {
                "text": "金神",
                "duizhao": ["癸酉", "己巳", "乙丑"]
            }
        }
    }
}